const ZURICH = "Europe/Zurich";

function parseInstant(s) {
  if (s == null || String(s).trim() === "") return null;
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Human-readable when for Infos / tiles: Europe/Zurich, de-CH.
 * Same calendar day: "DD.MM.YYYY, HH:mm – HH:mm". Spanning days: includes both dates.
 */
export function formatActivityWhenDeCh(startsAt, endsAt) {
  const start = parseInstant(startsAt);
  if (!start) return "";
  const end = parseInstant(endsAt);
  const dateFmt = new Intl.DateTimeFormat("de-CH", {
    timeZone: ZURICH,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const timeFmt = new Intl.DateTimeFormat("de-CH", {
    timeZone: ZURICH,
    hour: "2-digit",
    minute: "2-digit",
  });
  const dateStr = dateFmt.format(start);
  const startTime = timeFmt.format(start);
  if (!end || end.getTime() <= start.getTime()) {
    return `${dateStr}, ${startTime}`;
  }
  const endDateStr = dateFmt.format(end);
  const endTime = timeFmt.format(end);
  if (endDateStr === dateStr) {
    return `${dateStr}, ${startTime} – ${endTime}`;
  }
  return `${dateStr}, ${startTime} – ${endDateStr}, ${endTime}`;
}
